export default __webpack_public_path__ + "static/media/annex14.25ea7497.png";